import { defineMessages } from 'react-intl';

export default defineMessages({
  inactiveSortLabel: {
    id: 'frontbucket.branches.inactiveSortLabel',
    description:
      'Text for the screen reader label on columns that are not being sorted by',
    defaultMessage: 'Not currently sorting by {sortLabel}',
  },
  headerName: {
    id: 'frontbucket.branches.headerName',
    description: 'Text for "name" column header in branch list',
    defaultMessage: 'Branch',
  },
  headerBehind: {
    id: 'frontbucket.branches.headerBehind',
    description: 'Text for "behind" column header in branch list',
    defaultMessage: 'Behind',
  },
  headerAhead: {
    id: 'frontbucket.branches.headerAhead',
    description: 'Text for "ahead" column header in branch list',
    defaultMessage: 'Ahead',
  },
  headerUpdated: {
    id: 'frontbucket.branches.headerUpdated',
    description: 'Text for "updated" column header in branch list',
    defaultMessage: 'Updated',
  },
  headerPullRequest: {
    id: 'frontbucket.branches.headerPullRequest',
    description: 'Text for "Pull request" column header in branch list',
    defaultMessage: 'Pull request',
  },
  headerBuilds: {
    id: 'frontbucket.branches.headerBuilds',
    description: 'Text for "Builds" column header in branch list',
    defaultMessage: 'Builds',
  },
  select: {
    id: 'frontbucket.branches.tableHeaders.branchSelectColumn',
    description:
      'Tooltip and aria-label text for "select" column header in branch list',
    defaultMessage: 'Select branches',
  },
  headerActions: {
    id: 'frontbucket.branches.headerActions',
    description: 'Text for "Actions" column header in branch list',
    defaultMessage: 'Actions',
  },
  name: {
    id: 'frontbucket.branches.tableHeaders.branchNameColumn',
    description:
      'Tooltip and aria-label text for "name" column header in branch list',
    defaultMessage: 'List of branches',
  },
  behind: {
    id: 'frontbucket.branches.tableHeaders.behindColumn',
    description:
      'Tooltip and aria-label text for "behind" column header in branch list',
    defaultMessage: 'Number of commits behind master',
  },
  ahead: {
    id: 'frontbucket.branches.tableHeaders.aheadColumn',
    description:
      'Tooltip and aria-label text for "ahead" column header in branch list',
    defaultMessage: 'Number of commits ahead of master',
  },
  updated: {
    id: 'frontbucket.branches.tableHeaders.updatedColumn',
    description:
      'Tooltip and aria-label text for "updated" column header in branch list',
    defaultMessage: 'Time of last activity',
  },
  pullRequest: {
    id: 'frontbucket.branches.tableHeaders.pullRequestColumn',
    description:
      'Tooltip and aria-label text for "Pull requestColumn" column header in branch list',
    defaultMessage: 'Status and ID of pull requests',
  },
  builds: {
    id: 'frontbucket.branches.tableHeaders.buildsColumn',
    description:
      'Tooltip and aria-label text for "Builds" column header in branch list',
    defaultMessage: 'Status of builds',
  },
});
